<template>
  <div class="container">
    <div class="card-main flex-csc">
      <img class="success-img" src="../../assets/images/commentSuccess.png" alt="" />
      <div v-if="flag">
        <h2>{{msg}}</h2>
        <div class="card-info" :style="{backgroundImage: 'url('+ info.backgroundPic +')', backgroundSize:'cover' }">
          <div>姓名： {{info.userName}}</div>
          <div>卡号： {{info.cardNo}}</div>
          <div v-if="info.count > 0">次数： {{info.count}}</div>
          <div v-else>余额： {{info.balanceStr}}</div>
          <div v-if="info.discount && info.discount < 100">折扣： {{info.discount / 10}}折</div>
        </div>
        <div class="card-msg">温馨提示：{{info.remark}}</div>
      </div>
      <div class="fs-18 clr-6" v-else>
        {{failMsg}}
      </div>
    
    </div>
  </div>
</template>

<script>
  export default {
    name: 'openCardSuccess',
    data () {
      return {
        info: {},
        msg: '',
        back: false,
        tradeNo: '',
        flag: false,
        ajaxNum: 0,
        failMsg: '支付查询中，请耐心等待。'
      }
    },
    mounted () {
      const { router = '', tradeNo = '' } = this.$route.query
      console.log('router', router)
      console.log('tradeNo', tradeNo)
      this.tradeNo = tradeNo
      this.initDate(router)
      this.chagerInfo()
    },
    methods: {
      initDate (router) {
        if (router === 'openCard') {
          this.msg = '恭喜您办卡成功'
        } else if (router === 'recharge') {
          this.msg = '恭喜您充值成功'
        }
      },
      chagerInfo () {
        const {tradeNo} = this
        this.$api.pay.chagerInfoApi({
          tradeNo
        }).then(res => {
          console.log('chagerInfoApi', res)
          if (res.errCode === '0') {
            this.ajaxNum++
            const { info = {}, flag } = res.data
            this.flag = flag
            this.info = info
            if (!flag) {
              if (this.ajaxNum < 4) {
                setTimeout(() => {
                  this.chagerInfo()
                }, 1500)
              } else {
                this.failMsg = '支付查询失败'
              }
            }
          } else {
            this.$toast(res.errMsg)
          }
        })
      }
    }
  }
</script>

<style scoped lang="stylus">
  .container
    position relative
    height 100vh
    background #fff
    .card-main
      padding-top 20px
      height calc(100vh - 100px)
      .success-img
        width 80px
        height 85px
      .card-img
        width 145px
        height 77px
      h2
        font-size 19px
        font-weight bold
        line-height 5em
        text-align center
      .card-info
        box-sizing border-box
        padding 30px 20px
        width 280px
        height 140px
        border-radius 8px
        overflow hidden
        color #fff
        > div
          font-size 14px
          font-weight 500
          line-height 1.5
      .card-msg
        margin-top 10px
        width 280px
        font-size 12px
        color #5A5A5A
        line-height 2em
    .btn-box
      margin-top 10px
    .button-default
      width 45%
    .pay-msg
      text-align center
</style>
